import { Types } from "../actions/BreakDownListTableActions";

const initialState = {
    reasonGroupData: [],
    effectList: [],
    techList: [],
    costCenter: [],
    poolList: [],
    breakDownData: [],
    statusList: [],
    areaList: {},
    subEquipmentList: {},
};

export const breakDownListTableReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BREAK_DOWN_TABLE_REASON_GROUP:
            return {
                ...state,
                reasonGroupData: action.payload?.resultObject || [],
            };

        case Types.SET_BREAK_DOWN_TABLE_EFFECT_LIST:
            return {
                ...state,
                effectList: action.payload?.resultObject || [],
            };

        case Types.SET_BREAK_DOWN_TABLE_TECHLIST:
            return {
                ...state,
                techList: action.payload || [],
            };
        case Types.SET_BREAK_DOWN_TABLE_COST_CENTER:
            return {
                ...state,
                costCenter: action.payload?.resultObject || [],
            };
        case Types.SET_BREAK_DOWN_TABLE_POOL_LIST:
            return {
                ...state,
                poolList: action.payload?.resultObject || [],
            };
        case Types.SET_BREAK_DOWN_TABLE_STATUS_LIST:
            return {
                ...state,
                statusList: action.payload?.resultObject || [],
            };
        case Types.SET_BREAK_DOWN_TABLE_DATA:
            return {
                ...state,
                breakDownData: action.payload?.resultObject || [],
            };
        case Types.SET_BREAK_DOWN_TABLE_AREA_LIST:
            return {
                ...state,
                areaList: action.payload || {},
            };
        case Types.SET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST:
            return {
                ...state,
                subEquipmentList: action.payload || {},
            };
        case Types.RESET_BREAK_DOWN_TABLE_DATA:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
